<template>
    <article ref="detail" class="medium-7">
      <slot name="notes"></slot>
      <slot></slot>
      <slot name="clientInfo"></slot>
    </article>
</template>

<script>
    export default {
      data() {
        return {
          client: this.$route.params.client
        }
      },
      mounted() {
        // TweenMax.to(this.$refs.detail, 0.6, {autoAlpha: 1});
      }
    }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/PortfolioDetail.vue